// extracted by mini-css-extract-plugin
export default {"container":"X_-z","title":"Y_-z","link":"Z_-z"};